import React, { Fragment,memo } from 'react'
// Project File Imports
// Material UI Imports
import SideScreenDrawer from './SideScreenDrawer'

const SideScreen = (props) => {
  const { sideScreens } = props

  return (
    <Fragment>
      <SideScreenDrawer sideScreen={sideScreens[0]} primary={true} />
      {sideScreens.map(
        (sideScreen, index) =>
        index !== 0 && (
          <SideScreenDrawer index={index} sideScreen={sideScreen}></SideScreenDrawer>
          )
          )}
    </Fragment>
  )
}
export default memo(SideScreen);